import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      home: "Home",
      services: "Services",
      about: "About",
      reviews: "Reviews",
      contact: "Contact",
      toggle: "עברית",
      doctorAlt: "Doctor Group",
      aboutTitle: "About Dr. Shada Habib",
      aboutDescription: `Welcome to Dr. Shada Habib’s clinic, where we prioritize your mental well-being. 
        With over a decade of experience in psychiatry and a specialization in PTSD, 
        Dr. Shada and her dedicated team are committed to providing compassionate, 
        evidence-based care. Our goal is to help you heal and thrive emotionally, 
        mentally, and physically.`,
      solutionsTitle: "Your Solutions",
      personalizedConsultationTitle: "Personalized Consultation",
      personalizedConsultationDescription: `Book a consultation with Dr. Shada to discuss your mental health journey. 
        We tailor every session to suit your unique needs and goals.`,
      createTreatmentPlanTitle: "Create a Treatment Plan",
      createTreatmentPlanDescription: `Work with Dr. Shada to develop a customized treatment plan. From therapy 
        sessions to lifestyle adjustments, we ensure your recovery is comprehensive.`,
      achievePeaceOfMindTitle: "Achieve Peace of Mind",
      achievePeaceOfMindDescription: `With expert guidance and compassionate support, you’ll progress toward 
        emotional balance and mental well-being, empowering you to live a fulfilling life.`,
        bookAppointmentOnline: "Book Appointment Online",
        patientFullName: "Patient Full Name",
        patientPhoneNumber: "Patient Phone Number",
        patientGender: "Patient Gender",
        select: "Select",
        male: "Male",
        female: "Female",
        informDoctor: "I will inform Doctor only",
        preferredAppointmentTime: "Preferred Appointment Time",
        preferredMode: "Preferred Mode",
        voiceCall: "Voice Call",
        videoCall: "Video Call",
        meeting: "Meeting",
        confirmAppointment: "Confirm Appointment",
        appointmentSent: "Appointment details have been sent via WhatsApp.",
        appointmentScheduled: "Appointment Scheduled!",
        appointmentDetails: "New Appointment Details",
        patientNameRequired: "Patient name is required",
        patientNameLength: "Patient name must be at least 8 characters",
        patientPhoneRequired: "Patient phone number is required",
        patientPhoneLength: "Patient phone number must be of 10 digits",
        selectGender: "Please select patient gender",
        appointmentTimeRequired: "Appointment time is required",
        selectFutureTime: "Please select a future appointment time",
        selectMode: "Please select preferred mode",
      whyChooseDrShahada: "Why Choose Dr. Shada Habib?",
      baDescription: "Discover the reasons to trust Dr. Shada Habib for your mental health care. With a compassionate approach, expert knowledge in PTSD, and personalized treatment plans, Dr. Shada is dedicated to guiding you toward emotional well-being and peace of mind.",
      specializedInPTSD: "Specialized in PTSD and Trauma",
      compassionateCare: "Compassionate, Patient-Centered Care",
      evidenceBasedPlans: "Evidence-Based Treatment Plans",
      flexibleScheduling: "Flexible Appointment Scheduling",
      bookAppointment: "Book Appointment",
      footerDescription: "Dedicated to your mental well-being, Dr. Shada Habib provides compassionate care, expert advice, and personalized treatments to help you overcome PTSD and mental health challenges. Your journey to emotional balance starts here.",
      legal: "Legal",
      talkToUs: "Talk To Us",
      ptsdTreatment: "PTSD Treatment",
      emotionalSupport: "Emotional Support",
      holisticMentalHealth: "Holistic Mental Health",
      therapySessions: "Therapy Sessions",
      mentalHealthEducation: "Mental Health Education",
      generalInfo: "General Info",
      privacyPolicy: "Privacy Policy",
      termsOfServices: "Terms of Services",
      consultations: "Consultations",
      howItWorks: "How it Works",
      yourMentalHealthMatters: "🧠 Your Mental Health Matters",
      meetDrShahada: "Meet Dr. Shada Psychiatrist PTSD Specialist",
      heroDescription: "Dr. Shada Habib is a compassionate psychiatrist with over a decade of experience helping individuals overcome PTSD and other mental health challenges. Book a session today to start your journey toward healing.",
      happyPatients: "Happy Patients",
      yearsOfExperience: "Years of Experience",
      ptsdPrograms: "PTSD Programs",
      doctor: "Doctor",
      whatWeDo: "What We Do",
      infoDescription: "At Dr. Shada Habib's clinic, we prioritize your mental well-being. We offer compassionate care and evidence-based treatments tailored to address PTSD, emotional health, and overall mental wellness. Our goal is to empower you to live a balanced, fulfilling life.",
      ptsdTreatmentTitle: "PTSD Treatment",
      ptsdTreatmentDescription: "Specializing in PTSD, Dr. Shada provides a range of therapy options, including cognitive-behavioral therapy (CBT) and EMDR. With a personalized approach, we aim to help you overcome trauma and regain control over your life.",
      emotionalSupportTitle: "Emotional Support",
      emotionalSupportDescription: "We understand the importance of emotional resilience. Dr. Shahada offers individual therapy sessions designed to support you through life's challenges, whether it's stress, anxiety, or depression.",
      holisticMentalHealthTitle: "Holistic Mental Health",
      holisticMentalHealthDescription: "With a focus on holistic care, we address the connection between mind and body. Dr. Shada combines mindfulness, lifestyle adjustments, and mental health education to guide you toward lasting well-being.",
      generalInfoTitle: "General Info",
      generalInfoDescription: "Welcome to The system, your trusted online the system platform. Our mission is to provide accessible and personalized the system services to individuals seeking expert medical advice and treatment. By using our platform, you agree to the terms outlined in our Privacy Policy and Terms of Service.",
      privacyPolicyTitle: "Privacy Policy",
      privacyPolicyDescription: "Your privacy is paramount to us. Our Privacy Policy outlines how we collect, use, and protect your personal and medical information. We ensure secure data handling, and you can trust that your information is treated with the utmost confidentiality.",
      termsOfServiceTitle: "Terms of Service",
      termsOfServiceDescription: "When using The system, you agree to our Terms of Service. This includes guidelines for using our platform, interacting with doctors, and the responsibilities of both parties. It's essential to understand these terms to ensure a smooth experience for all users.",
      consultationsTitle: "Consultations",
      consultationsDescription: "Our platform connects you with expert doctors who provide online consultations. These consultations are not a replacement for in-person medical visits but serve as a convenient option for medical advice, prescriptions, and guidance. It's crucial to provide accurate and complete information to receive the best possible care.",
      howItWorksTitle: "How it Works",
      howItWorksDescription: "The system is designed to simplify the system access. You can choose a specialist, schedule an appointment, and engage in a virtual consultation. Our specialists offer personalized advice and treatment plans tailored to your needs. Please remember that emergencies require immediate medical attention and should be directed to your local medical facility.",
      customersReview: "More over {{count}}+ Customers",
      checkClientsWords: "Don't believe us, Check clients word",
    },
  },
  he: {
    translation: {
      home: "דף הבית",
      services: "שירותים",
      about: "אודות",
      reviews: "ביקורות",
      contact: "צור קשר",
      toggle: "English",
      doctorAlt: "קבוצת רופאים",
      aboutTitle: "אודות ד\"ר שחאדה חביב",
      aboutDescription: `ברוכים הבאים למרפאתו של ד"ר שחאדה חביב, בה אנו שמים דגש על רווחתכם הנפשית. 
        עם למעלה מעשור של ניסיון בפסיכיאטריה והתמחות בהפרעת דחק פוסט-טראומטית (PTSD), 
        ד"ר שחאדה וצוותו המסור מחויבים לספק טיפול עדין ומבוסס מחקר. מטרתנו היא לעזור לכם 
        להחלים ולהצליח רגשית, נפשית ופיזית.`,
      solutionsTitle: "הפתרונות שלכם",
      personalizedConsultationTitle: "ייעוץ מותאם אישית",
      personalizedConsultationDescription: `קבעו פגישה עם ד"ר שחאדה כדי לדון במסע הבריאות הנפשית שלכם. 
        אנו מתאימים כל מפגש לצרכים ולמטרות הייחודיות שלכם.`,
      createTreatmentPlanTitle: "יצירת תוכנית טיפול",
      createTreatmentPlanDescription: `עבדו עם ד"ר שחאדה לפיתוח תוכנית טיפול מותאמת אישית. 
        החל מפגישות טיפוליות ועד התאמות באורח החיים, אנו דואגים שההחלמה שלכם תהיה מקיפה.`,
      achievePeaceOfMindTitle: "השגת שלוות נפש",
      achievePeaceOfMindDescription: `עם הדרכה מקצועית ותמיכה עדינה, תתקדמו לעבר איזון רגשי ורווחה נפשית, 
        שיעצימו אתכם לחיות חיים מלאים ומספקים.`,
        bookAppointmentOnline: "תיאום תורים אונליין",
        patientFullName: "שם המטופל",
        patientPhoneNumber: "מספר טלפון המטופל",
        patientGender: "מין המטופל",
        select: "בחר",
        male: "זכר",
        female: "נקבה",
        informDoctor: "אודיע לרופא בלבד",
        preferredAppointmentTime: "זמן התור המועדף",
        preferredMode: "האופן המועדף",
        voiceCall: "שיחת טלפון",
        videoCall: "שיחת וידאו",
        meeting: "פגישה",
        confirmAppointment: "אישור תור",
        appointmentSent: "פרטי התור נשלחו ב-WhatsApp",
        appointmentScheduled: "התור נקבע בהצלחה!",
        appointmentDetails: "פרטי התור החדשים",
        patientNameRequired: "יש למלא את שם המטופל",
        patientNameLength: "שם המטופל חייב להיות באורך של לפחות 8 תווים",
        patientPhoneRequired: "יש למלא את מספר הטלפון של המטופל",
        patientPhoneLength: "מספר הטלפון חייב להיות באורך של 10 ספרות",
        selectGender: "נא לבחור מין",
        appointmentTimeRequired: "יש לבחור זמן לתור",
        selectFutureTime: "נא לבחור זמן תור עתידי",
        selectMode: "נא לבחור את האופן המועדף לתור",
        whyChooseDrShahada: "למה לבחור בד\"ר שחאדה חביב?",
        baDescription: "גלו את הסיבות לבחור בד\"ר שחאדה חביב לטיפול בבריאות הנפשית שלכם. בגישה אוהבת, ידע מומחה ב-PTSD ותוכניות טיפול אישיות, ד\"ר שחאדה מחויב להוביל אתכם לרווחה רגשית ונפשית.",
        specializedInPTSD: "מומחה ב-PTSD וטראומה",
        compassionateCare: "טיפול מכבד וממוקד בחולה",
        evidenceBasedPlans: "תוכניות טיפול מבוססות ראיות",
        flexibleScheduling: "תיאום תורים גמיש",
        bookAppointment: "קביעת תור",
      footerDescription: "מחויבת לרווחתכם הנפשית, ד\"ר שחאדה חביב מספק טיפול אוהב, ייעוץ מומחה וטיפולים אישיים שיעזרו לכם להתמודד עם PTSD ואתגרים בריאות נפש. המסע שלכם לאיזון רגשי מתחיל כאן.",
      legal: "משפטי",
      talkToUs: "דברו איתנו",
      ptsdTreatment: "טיפול ב-PTSD",
      emotionalSupport: "תמיכה רגשית",
      holisticMentalHealth: "בריאות נפשית הוליסטית",
      therapySessions: "מפגשי טיפול",
      mentalHealthEducation: "השכלה בבריאות נפש",
      generalInfo: "מידע כללי",
      privacyPolicy: "מדיניות פרטיות",
      termsOfServices: "תנאי שירות",
      consultations: "ייעוץ",
      howItWorks: "איך זה עובד",
      yourMentalHealthMatters: "🧠 הבריאות הנפשית שלך חשובה",
      meetDrShahada: "הכירו את ד\"ר שחאדה, מומחה לפסיכיאטריה ו-PTSD",
      heroDescription: "ד\"ר שחאדה חביב הוא פסיכיאטר מסור עם למעלה מעשור של ניסיון בטיפול באנשים המתמודדים עם PTSD ואתגרי בריאות נפש אחרים. קבעו מועד לפגישה היום כדי להתחיל במסעכם לריפוי.",
      happyPatients: "מטופלים מרוצים",
      yearsOfExperience: "שנות ניסיון",
      ptsdPrograms: "תוכניות לטיפול ב-PTSD",
      doctor: "רופא",
      whatWeDo: "מה אנו עושים",
      infoDescription: "במרפאתו של ד\"ר שחאדה חביב, אנו מעמידים בראש סדר העדיפויות את רווחתכם הנפשית. אנו מציעים טיפול אוהב ומבוסס על ראיות, המותאם לטיפול ב-PTSD, בריאות הרגש וברווחה הנפשית כוללת. מטרתנו היא לאפשר לכם חיים מאוזנים ומספקים.",
      ptsdTreatmentTitle: "טיפול ב-PTSD",
      ptsdTreatmentDescription: "מתמחה ב-PTSD, ד\"ר שחאדה מציעה מגוון אופציות לטיפול, כולל טיפול קוגניטיבי התנהגותי (CBT) ו-EMDR. באמצעות גישה אישית, אנו שואפים לעזור לך להתגבר על הטראומה ולשחזר את שליטתך בחייך.",
      emotionalSupportTitle: "תמיכה רגשית",
      emotionalSupportDescription: "אנו מבינים את חשיבות העמידות הרגשית. ד\"ר שחאדה מציעה מפגשי טיפול אישיים המיועדים לתמוך בך באתגרי החיים, בין אם מדובר בלחץ, חרדה או דיכאון.",
      holisticMentalHealthTitle: "בריאות נפשית הוליסטית",
      holisticMentalHealthDescription: "במיקוד בטיפול הוליסטי, אנו מתייחסים לקשר בין הנפש לגוף. ד\"ר שחאדה משלבת מיינדפולנס, התאמות באורח החיים והשכלה בבריאות נפש להדרכתך לעבר רווחה ארוכת טווח.",
      generalInfoTitle: "מידע כללי",
      generalInfoDescription: "ברוכים הבאים ל-ד''ר שחאדה, הפלטפורמה שלכם לבריאות אונליין. משימתנו היא לספק שירותי בריאות נגישים ומותאמים אישית לאנשים המחפשים ייעוץ רפואי מקצועי וטיפול. בשימוש בפלטפורמה שלנו, אתם מסכימים לתנאים המתוארים במדיניות הפרטיות ותנאי השירות שלנו.",
      privacyPolicyTitle: "מדיניות פרטיות",
      privacyPolicyDescription: "הפרטיות שלכם חשובה לנו מאוד. מדיניות הפרטיות שלנו מתארת איך אנו אוספים, משתמשים, ומגנים על המידע האישי והרפואי שלכם. אנו מבטיחים טיפול בטוח בנתונים, ותוכלו לסמוך על כך שהמידע שלכם מטופל בסודיות מרבית.",
      termsOfServiceTitle: "תנאי שירות",
      termsOfServiceDescription: "בשימוש ב-ד''ר שחאדה, אתם מסכימים לתנאי השירות שלנו. זה כולל הנחיות לשימוש בפלטפורמה שלנו, אינטראקציה עם רופאים, והאחריותות של שתי הצדדים. חשוב להבין את התנאים האלה כדי להבטיח חוויה חלקה לכל המשתמשים.",
      consultationsTitle: "ייעוצים",
      consultationsDescription: "הפלטפורמה שלנו מחברת אתכם עם רופאים מומחים שמספקים ייעוצים אונליין. ייעוצים אלו אינם מחליפים ביקורים רפואיים פרטניים אך מהווים אופציה נוחה לייעוץ רפואי, מרשמים, והדרכה. חשוב לספק מידע מדויק ומלא כדי לקבל את הטיפול הטוב ביותר.",
      howItWorksTitle: "איך זה עובד",
      howItWorksDescription: "ד''ר שחאדה מעוצבת להפוך את הגישה לבריאות לפשוטה יותר. תוכלו לבחור מומחה, לתאם פגישה, ולהשתתף בייעוץ וירטואלי. המומחים שלנו מציעים ייעוץ ותוכניות טיפול מותאמות אישית לצרכים שלכם. זכרו שמקרי חירום דורשים טיפול רפואי מיידי ויש לפנות למתקן הרפואי הקרוב.",
          customersReview: "למעלה מ-{{count}}+ לקוחות",
      checkClientsWords: "לא סומכים עלינו?, בדקו את מילות הלקוחות"

    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "he",
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
